
function Contact() {

    return (
        <div id="contact">
            <div className="head">
                <h1>Contact</h1>
            </div>
            <div className="body">
                <p>isaacjdjreyes@gmail.com</p>
                <a href="https://github.com/css-enjoyer/DotAI" target="_blank" rel="noreferrer">Project GitHub</a>
                <a href="https://css-enjoyer.github.io/portfolio/" target="_blank" rel="noreferrer">My Portfolio</a>
                <a href="https://github.com/css-enjoyer" target="_blank" rel="noreferrer">My GitHub</a>
            </div>
        </div>
    );
}
export default Contact;
